import * as deploy from './deploy.js';
import * as download from './download.js';

export const env = [deploy, download];
